import React from "react";
import { asField } from "informed";
import $ from "jquery";
import FormHelper from "./helper";

const Checkbox = asField(({ fieldApi, fieldState, ...props }) => {
  const { value } = fieldState;
  const { setValue, setTouched } = fieldApi;
  const {
    onChange,
    onBlur,
    field,
    initialValue,
    debug,
    forwardedRef,
    id,
    label,
    ...rest
  } = props;
  return (
    <>
      {label ? <label htmlFor={id}> {label} </label> : null}

      <input
        {...rest}
        id={id}
        name={field}
        ref={forwardedRef}
        checked={!!value}
        onChange={(e) => {
          setValue(e.target.checked);
          if (onChange) {
            onChange(e);
          }
        }}
        onBlur={(e) => {
          setTouched(true);
          if (onBlur) {
            onBlur(e);
          }
        }}
        type="checkbox"
      />
      {props.helper && <FormHelper content={props.helper} />}

      {fieldState.error ? (
        <div className="invalid-field">{fieldState.error}</div>
      ) : null}
    </>
  );
});

const CheckboxGroup = (props) => {
  function onChange(e, val) {
    props.onChange(e, val, false);
  }
  function SelectAll(e) {
    let all = [];
    if (e.target.checked) {
      all = props.options.map((ele) => ele.value);

      console.log($("#cvbnm").find("label input[type=checkbox]"));
      $("#cvbnm").find("label input[type=checkbox]").prop("checked", true);
    }
    console.log("all", all);
    props.onChange(e, all, true);
  }

  return (
    <div className="form-group">
      <label>
        <Checkbox
          style={{ marginRight: "4px" }}
          field="all"
          onChange={(e) => SelectAll(e)}
        />{" "}
        Select All Facility
      </label>
      <div id="cvbnm">
        {props.options &&
          props.options.map((option, i) => (
            <label htmlFor={option.value} style={{ marginRight: "10px" }}>
              {" "}
              <Checkbox
                className="mnbvczxvzxgxz"
                style={{ marginRight: "1px", background: "#3d404e" }}
                field={option.value}
                onChange={(e) => onChange(e, option.value)}
              />{" "}
              {option.label}
            </label>
          ))}
      </div>
    </div>
  );
};
export default CheckboxGroup;
